import moment from "moment";
import { useState, useCallback, useEffect } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate, useLocation } from "react-router";
import { Button, Skeleton,Checkbox } from "@mui/material";
import NoDataCard from "../../../components/no-data-card";
import { dateFormater } from "../../utils/common/utils";
import ResetLSMApheresis from "./taskModel";
import { findSlugString} from '../../../../src/utils/utils'
import BsModal from "../../components/common/BaseModal"
import AddUpdatePayment from "./AddUpatePayment";
import { setOperationTitle } from "../../../store/reducers/operation";
import { useDispatch } from "react-redux";
import { feasibilityPaymentStatus } from "../../slices/apheresis";

const getTaskRedirectUrl = (taskDetails, batchNo, pathname, useBmrRoutes = false) => {
  const redirectUri = taskDetails?.redirect_uri;

  if (!redirectUri) {
    return "";
  }

  const isBMRSection = useBmrRoutes || pathname.includes("/bmr/");
  const phasePatientMatch = redirectUri.match(
    /^\/phases\/phase-details\/[^/]+\/patient-details\/([^/?#]+)(.*)?$/
  );

  if (isBMRSection && phasePatientMatch) {
    return `/bmr/feasibility-assessment/subjects/details/${phasePatientMatch[1]}${batchNo}`;
  }

  return batchNo ? redirectUri + batchNo : redirectUri;
};

const TaskNotificationTile = ({
  task = [],
  isClosed,
  canSelect,
  loadMoreData,
  maxPages,
  page,
  loading,
  hasMoreData = true,
  hideActions = false,
  showBoxShadow = false,
  useBmrRoutes = false,
  onArchiveTask,
  onUnarchiveTask,
  isArchived,
  selectedIds = new Set(),
  setSelectedIds,
  isModalOpenRef,
  refreshAction,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  // const [hasTriedLoadMore, setHasTriedLoadMore] = useState(false);
  const [openModel, setModel] = useState(false);
  const [openModelTask, setOpenModelTask] = useState({});
  const [paymentStatusModal, setPaymentStatusModal] = useState(false);
  const [rowData, setRowData]=useState({})
 const dispatch = useDispatch()
  const [, setIsFetchingPayment] = useState(false);

    useEffect(() => {
    if (isModalOpenRef) {
      isModalOpenRef.current = paymentStatusModal || openModel;
    }
  }, [paymentStatusModal, openModel, isModalOpenRef]);

  // Clean up the ref when the component unmounts.
  useEffect(() => {
    return () => {
      if (isModalOpenRef) {
        isModalOpenRef.current = false;
      }
    };
  }, [isModalOpenRef]);
  useEffect(() => {
    if (!hasMoreData || !loading) {
      setIsLoadingMore(false);
    }
  }, [task.length, hasMoreData, loading]);

  const handleCloseModal = (isSuccess) => {
    setPaymentStatusModal(false);
    if (isSuccess === true && refreshAction) {
      refreshAction();
    }
  }
  const handleTaskView = async (taskDetails) => {
    setRowData(taskDetails)
  const operationTitle = findSlugString(taskDetails?.slug) || "";
    if (taskDetails?.status == "0" || taskDetails?.status == 0) {
      await dispatch(setOperationTitle(operationTitle));
    }
    const batchNo = taskDetails?.batch_no ? '?batch=' + taskDetails?.batch_no : '';
    if (findSlugString(taskDetails?.slug) == "payment-status" && taskDetails?.status === 0) {
      if (isModalOpenRef) {
        isModalOpenRef.current = true;
      }
      setIsFetchingPayment(true);
  try {
        await dispatch(feasibilityPaymentStatus({
          id: taskDetails?.feasibility_assessments_id
        }));
        setPaymentStatusModal(true)
        setOpenModelTask(taskDetails)
      } catch (err) {
        console.error(err);
        if (isModalOpenRef) {
          isModalOpenRef.current = false;
        }
      } finally {
        setIsFetchingPayment(false);
      }
    } else if (findSlugString(taskDetails?.slug) == "lsm-rejection" && taskDetails.status == 0) {
      if (isModalOpenRef) {
        isModalOpenRef.current = true;
      }
      setModel(true)
      setOpenModelTask(taskDetails)
    } else {
    const subjectId = taskDetails?.subject?.id;
      if (taskDetails?.redirect_uri) {
        const url = getTaskRedirectUrl(taskDetails, batchNo, location.pathname, useBmrRoutes);
      navigate(url, {
        state: { subject_id: subjectId,  task_slug: taskDetails?.slug, }
      });
      } else {
        const prodDetailsId = taskDetails?.subject?.phase?.product_details?.id;
        const phaseId = taskDetails?.subject?.id;
        const isBMRSection = useBmrRoutes || location.pathname.includes("/bmr/");

      const path = isBMRSection
        ? `/bmr/products/product-details/${prodDetailsId}/patient-details/${phaseId}${batchNo}`
        : `/products/product-details/${prodDetailsId}/patient-details/${phaseId}${batchNo}`;
      navigate(path, {
        state: { subject_id: subjectId,  task_slug: taskDetails?.slug, }
      });
    }
  }
};
  const handleArchiveSelected = () => {
  if (onArchiveTask && selectedIds.size > 0) {
    onArchiveTask(selectedIds);
  }
};
const handleUnarchiveSelected = () => {
  if (onUnarchiveTask && selectedIds.size > 0) {
    onUnarchiveTask(selectedIds);
  }
};

  const getTaskColorAndDate = (createdAt, isClosed) => {
    const today = moment().startOf("day");
    const createdDate = moment(createdAt).startOf("day");
    const diffInDays = today.diff(createdDate, "days");

    if (isClosed) {
      return {
        taskColor: "#00B278",
        dateText:
          diffInDays === 0
            ? "Today"
            : `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`,
      };
    }

    if (diffInDays === 0) {
      return {
        taskColor: "#3b82f6",
        dateText: "Today",
      };
    } else if (diffInDays <= 3) {
      return {
        taskColor: "#f97316",
        dateText: `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`,
      };
    }

    return {
      taskColor: "#ef4444",
      dateText: `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`,
    };
  };

  const hasMore = useCallback(() => {
    if (loading || isLoadingMore) {
      return false;
    }

    // Use explicit hasMoreData prop if available
    if (hasMoreData !== undefined) {
      return hasMoreData;
    }

    // Fallback to page-based logic
    if (typeof page === "number" && typeof maxPages === "number") {
      return page < maxPages;
    }

    return false;
  }, [loading, isLoadingMore, hasMoreData, page, maxPages]);

  // FIXED: Improved load more handler
  const handleLoadMore = useCallback(() => {
    if (isLoadingMore || !hasMore()) {
      return;
    }

    setIsLoadingMore(true);
    loadMoreData();
  }, [isLoadingMore, hasMore, loadMoreData]);

  // Loading state for initial load
  if (loading && task.length === 0) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, index) => (
          <Skeleton key={index} height={"150px"} />
        ))}
      </div>
    );
  }

  // Empty state
  if (!loading && task?.length === 0) {
    return (
      <div className="col-start-4 col-end-13">
        <NoDataCard heading="No Data to Display" />
      </div>
    );
  }

  return (
    <>
     <div className="flex flex-col "style={{ height: "100%", minHeight: 0, overflow: "hidden" }}>
    <div
      id="scrollableTaskContainer"
        style={{ flex: 1, overflowY: "auto", minHeight: 0 }}
    >
    <InfiniteScroll
      dataLength={task?.length || 0}
      next={handleLoadMore}
      hasMore={hasMore()}
           scrollableTarget="scrollableTaskContainer"
      loader={
        isLoadingMore ? (
          <div className="space-y-4">
            {[...Array(2)].map((_, index) => (
              <Skeleton key={`loading-${index}`} height={"150px"} />
            ))}
          </div>
        ) : null
      }
        endMessage={
          !hideActions && !hasMore() && task.length > 0 ? (
            <div className="text-center py-4 text-gray-500">
              <p>No more tasks to load</p>
            </div>
          ) : null
        }
      // Add these props to improve performance
      style={{ overflow: "visible" }}
      scrollThreshold={0.8}
    >
      {task.map((op, index) => {
        const { taskColor, dateText } = getTaskColorAndDate(
          op?.created_at,
          isClosed
        );
     const isChecked = selectedIds.has(op.id);
 
        return (
          <div
            key={`${op.id}-${index}`}
            className="bg-white flex flex-col md:flex-row justify-between rounded-md p-2 pt-2 border-l-4 mb-2 p-3"
            style={{
              borderLeftWidth: "2px",
              borderLeftColor: isClosed ? "#00B278" : taskColor,
              boxShadow: showBoxShadow ? "0px 2px 8px rgba(0, 0, 0, 0.1)" : "none"
            }}
          >
            {canSelect && (
             <div className="flex items-center pl-2 pr-1">
              <Checkbox
                checked={isChecked}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSelectedIds((prev) => {
                    const next = new Set(prev);
                    if (checked) {
                      next.add(op.id);
                    } else {
                      next.delete(op.id);
                    }
                    return next;
                  });
                }}
                size="small"
              />                  </div>
            )}
            <div className="task-start w-full md:w-[50%] pr-0 md:pr-4">
              <div>
                <span className="font-bold text-sm md:text-base block mb-1 capitalize">
                  {op?.title || "--"}
                </span>
                <div className="text-sm text-gray-400 pb-1">
                  {op?.description || "--"}
                </div>
                <div className="text-sm text-gray-500 pb-1">
                  Requested by: {op?.creator?.name || "--"}
                </div>
                <div>
                  {op.created_at ? (
                    <>
                      {dateFormater(op.created_at)}{" "}
                      <span
                        style={{
                          color: isClosed ? "#00B278" : taskColor,
                        }}
                      >
                        ({dateText})
                      </span>
                    </>
                  ) : (
                    "--"
                  )}
                </div>
              </div>
            </div>

            <div
              className={
                !isClosed
                  ? "mr-5 justify-end w-full md:w-[50%] flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-5 mt-3 sm:mt-0"
                  : "w-full md:w-[50%] flex flex-col sm:flex-row justify-around items-start sm:items-center gap-3 sm:gap-5 mt-3 sm:mt-0"
              }
            >
              {isClosed && (
                <div>
                  <p className="text-gray-500">Status</p>
                  <p className="font-bold text-sm text-gray-900 truncate">
                    {op?.status === 0 ? "Pending" : "Completed"}
                  </p>
                </div>
              )}
              
              <Button
                size="medium"
                variant="contained"
                onClick={() => handleTaskView(op)}
                className="pl-2 pr-2 sm:pl-5 sm:pr-5 w-35"
              >
                {findSlugString(op?.slug) == "assign-infusion" && op?.status === 0 ? 'Assign Infusion Date' : findSlugString(op?.slug) == "payment-status" && op?.status === 0 ? 'Update Payment Status' : findSlugString(op?.slug) == "lsm-rejection" && op?.status === 0 ? "Restart Apheresis" : "View Task"}
              </Button>
            </div>
        </div>
        );
      })}
      <ResetLSMApheresis
        open={openModel}
        taskDetails={openModelTask}
        setOpen={setModel}
      />
    </InfiniteScroll>
</div>
</div>
  {selectedIds.size > 0 && canSelect && (
          <div
            className="sticky z-10 bg-white border-t p-3 flex justify-end  absolute bottom-0 "
            style={{ marginTop: "24px" }}
          >
            <Button
              variant="contained"
              onClick={isArchived === 1 ? handleUnarchiveSelected : handleArchiveSelected}
              sx={{ borderRadius: "8px", textTransform: "none" }}
            >
              {isArchived === 1 ? "Unarchive Selected Task" : "Archive Selected Task"}
            </Button>
          </div>
        )}
<BsModal open={!!paymentStatusModal} onClose={() => setPaymentStatusModal(false)} title={'Update Payment Status'}>
          <AddUpdatePayment 
            editData={rowData}
            feasiblityId={rowData?.feasibility_assessments_id} 
            productManufacturingId={rowData?.product_manufacturing_id} 
            handleCloseModal={handleCloseModal} 
          />
        </BsModal>
</>
  );
};

export default TaskNotificationTile;
